import { defineMessages } from 'react-intl-next';
export var messages = defineMessages({
  quarterPickerButtonMessage: {
    id: 'date-range-picker.date-range-picker-content.quarter-picker-button-message',
    defaultMessage: 'Quarter',
    description: 'Button message for selecting quarter view of the calendar'
  },
  monthPickerButtonMessage: {
    id: 'date-range-picker.date-range-picker-content.month-picker-button-message',
    defaultMessage: 'Month',
    description: 'Button message for selecting month view of the calendar'
  },
  dayPickerButtonMessage: {
    id: 'date-range-picker.date-range-picker-content.day-picker-button-message',
    defaultMessage: 'Day',
    description: 'Button message for selecting day view of the calendar'
  }
});